import React from "react";
import "./Search.css";
import "../../styles/reset.css";
import clear from "../../assets/svg/clear.svg";
import search from "../../assets/svg/search.svg";


class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            value: "",
        };
    }

    handleSearchIconClick = (e) => {
        e.preventDefault();
        this.setState({ expanded: true })
    };

    handleClearIconClick = (e) => {
        e.preventDefault();
        if (this.state.value) {
            this.setState({ value: "" });
        } else {
            this.setState({ expanded: false });
        }
    };

    handleOnInput = (e) => {
        e.preventDefault();
        this.setState({ value: e.target.value });
    };

    render() {
        const { expanded, value } = this.state;

        return (
            <form className="search-form header__search-form header__search-form_focused">
                <button className="icon-button search-form__button"
                        onClick={this.handleSearchIconClick}>
                    <img src={search}/>
                </button>
                {
                    expanded &&
                    <React.Fragment><input className="search-form__input"
                                           type="search" autoFocus={true}
                                           value={value}
                                           placeholder="Search notes"
                                           onInput={this.handleOnInput}/>
                        <button className="icon-button search-form__button"
                                type="button"
                                onClick={this.handleClearIconClick}>
                            <img src={clear}/>
                        </button>
                    </React.Fragment>
                }
            </form>
        );
    }

}

export default Search;
